import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_08_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-08-01",
    "name": "绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["超级组第1个动作·三头", "大臂固定不晃动", "与绳索弯举交替无休息"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教跟练 · 第8期",
    "demoUrl": "/media/collections-20261008/demos/32ca231457f31ec57affcbe0.mp4",
    "videoUrl": "/media/collections-20261008/videos/66baf33334d56f03e26b37c6.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-08-02",
    "name": "坐姿绳索弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/ed593b69b409dea03519a326.mp4",
    "videoUrl": "/media/collections-20261008/videos/932adffad41418693c714105.mp4",
    "source": "私教跟练 · 第8期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-08-03",
    "name": "仰卧杠铃臂伸站姿弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "biceps",
    "tips": ["超级组·三头+二头组合", "仰卧杠铃臂屈伸接站姿弯举", "组间休息90秒"],
    "sets": 3,
    "reps": "10+10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教跟练 · 第8期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-86f404385b956d56c8e03733.mp4",
    "videoUrl": "/media/collections-20261008/videos/294f1d5bb37d6ecc0c7e137a.mp4",
    "targetMuscles": ["肱三头肌", "肱二头肌"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
